<template>
    <div>
      <plantVariety-note-type-list></plantVariety-note-type-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  